export default `:host {
  font-family: var(--ids-swappable-item-font-family);
  border: var(--ids-swappable-item-border-default);
  cursor: var(--ids-swappable-item-cursor-default);
  padding-inline: var(--ids-swappable-item-padding-inline);
  padding-block: var(--ids-swappable-item-padding-block);
  height: var(--ids-swappable-item-height);
  display: flex;
  flex-direction: row;
  transition: height 0.4s ease, padding 0.4s ease;
  overflow: hidden;
}

:host([hidden]) {
  display: none;
}

::slotted(.sortable) {
  width: 100%;
}

ids-icon {
  margin-inline: var(--ids-swappable-item-icon-margin-inline);
  visibility: hidden;
}

ids-icon[icon=drag] {
  inset-inline-start: 2px;
}

:host(:hover) ids-icon,
:host(.hover) ids-icon {
  visibility: visible;
}

:host([dir=rtl]:hover)::before {
  left: unset;
  right: 5px;
  transform: translate(-1px, -47%);
}

:host(:focus:not(.hide-focus)) {
  border: var(--ids-swappable-item-border-focus);
  box-shadow: var(--ids-swappable-item-shadow-focus);
  outline: var(--ids-swappable-item-outline-focus);
}

:host([selected]) {
  cursor: var(--ids-swappable-item-cursor-selected);
}

:host([dragging].touch-drag) {
  z-index: 99;
  position: absolute;
}

:host([dropped]) {
  transition: var(--ids-motion-duration) var(--ids-motion-ease);
}

:host(.dragging-clone) {
  opacity: var(--ids-swappable-item-opacity-dragging);
}

:host([dragging].mouse-drag) {
  opacity: var(--ids-swappable-item-opacity-dragging);
}

:host([dragging]:not(.slotted-ids-tab)),
:host(.dragging-clone:not(.slotted-ids-tab)),
:host([selected]:not(.slotted-ids-tab)) {
  background-color: var(--ids-swappable-item-color-background-selected);
  border: 1px solid var(--ids-swappable-item-color-border-selected);
  color: var(--ids-swappable-item-color-text-selected);
}

:host([over]) {
  border: var(--ids-swappable-item-over-border);
}

:host(.is-hidden) {
  height: var(--ids-space-none);
  padding: var(--ids-space-none);
  border: none;
  overflow: hidden;
}

::slotted(ids-tab) {
  position: relative;
  margin: -1px;
}

:host(.slotted-ids-tab:not(.orientation-vertical)) {
  margin-inline-start: var(--ids-space-2xs);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
